import React, { FC } from "react";
import avatar1 from "images/avatars/Image-1.png"; // Default image path
import { avatarColors } from "contains/contants"; // Colors for fallback avatars

export interface AvatarProps {
  containerClassName?: string;
  sizeClass?: string;
  radius?: string;
  imgUrl?: string;
  userName?: string;
  hasChecked?: boolean;
  hasCheckedClass?: string;
  // Off by default so every other place that uses Avatar looks the same as before.
  // When true and there is no image, show up to two initials (first and second word).
  showInitials?: boolean;
}

// "Hiva M." -> "HM", "Alina" -> "A"
const getInitials = (name: string): string => {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "";
  const first = Array.from(parts[0])[0] || "";
  const second = parts.length > 1 ? Array.from(parts[1])[0] || "" : "";
  return `${first}${second}`;
};

const Avatar: FC<AvatarProps> = ({
  containerClassName = "ring-1 ring-white dark:ring-neutral-900",
  sizeClass = "h-6 w-6 text-sm",
  radius = "rounded-full",
  imgUrl = avatar1,
  userName = "John Doe", // Default userName if not provided
  hasChecked,
  hasCheckedClass = "w-4 h-4 -top-0.5 -right-0.5",
  showInitials = false,
}) => {
  // Function to get background color based on the first letter of the name
  const _setBgColor = (name: string) => {
    const backgroundIndex = Math.floor(name.charCodeAt(0) % avatarColors.length);
    return avatarColors[backgroundIndex];
  };

  return (
    <div
      className={`wil-avatar relative flex-shrink-0 inline-flex items-center justify-center text-neutral-100 uppercase font-semibold shadow-inner ${radius} ${sizeClass} ${containerClassName}`}
      style={{ backgroundColor: imgUrl ? undefined : _setBgColor(userName) }}
    >
      {imgUrl ? (
        <img
          className={`absolute inset-0 w-full h-full object-cover ${radius}`}
          src={imgUrl}
          alt={userName}
        />
      ) : (
        <span className="wil-avatar__name">
          {showInitials ? getInitials(userName) : userName[0]}
        </span>
      )}

      {hasChecked && (
        <span
          className={` bg-teal-500 rounded-full text-white text-xs flex items-center justify-center absolute  ${hasCheckedClass}`}
        >
          <i className="las la-check"></i>
        </span>
      )}
    </div>
  );
};

export default Avatar;